import { Button } from 'antd'
import React from 'react'
import { useCreateEmployeeMutation } from '../../api/company.api'
import FormBuilder from '../../components/FormBuilder'
import { useMyContext } from '../../context/context'
import useSettingsV2 from '../../hooks/useSettingsV2'
import useTranslations from '../../hooks/useTranslations'
import { useSteps } from '../steps/Steps'

const CompanyCreate = ({ company, toList }) => {
  const { userId } = useSteps()
  const { settings: settingsV2 } = useSettingsV2()
  const { t } = useTranslations()
  const { myContext } = useMyContext()

  const [createEmployee] = useCreateEmployeeMutation()

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8, paddingTop: 16 }}>
      <div>
        <Button type="primary" onClick={toList}>
          {t('BACK')}
        </Button>
      </div>
      {/* <Form2 layout="horizontal" form={form2} initialValues={company}>
        <Form2.Item
          label={`${indexes[company.country]?.label || `${companyIndexLabel || 'SIREN de la société'}`}`}
          name="siren"
          rules={[{ required: true, message: 'Ce champ est obligatoire' }]}
          labelCol={{ span: 10 }}
        >
          <Input disabled={!!company?.siren} style={{ width: '100%' }} />
        </Form2.Item>
      </Form2> */}
      {settingsV2?.FO_MEETING_CREATE_COMPANY_FORM_ID && company && (
        <FormBuilder
          values={{ C: company }}
          formIdDefault={settingsV2.FO_MEETING_CREATE_COMPANY_FORM_ID}
          companyId={company.id || 0}
          employeeId={userId}
          onFinish={async c => {
            await createEmployee({ ...myContext, body: { userId, companyId: c.id } }).unwrap()
            toList(c.id)
          }}
        />
      )}

      {/* <Form
        company={company}
        form={form}
        onSaveCompany={onSubmit}
        NextButton={props => (
          <div style={{ display: 'flex', justifyContent: 'end', marginTop: 16 }}>
            <Button {...props} type="primary">
              {t('VALIDATE')}
            </Button>
          </div>
        )}
      /> */}

      {/* {(error?.data?.message === 'SIREN_EXISTS' || error1?.data?.message === 'SIREN_EXISTS') && (
        <Alert showIcon message={`${companyIndexLabel} est déjà utilisé, veuillez contacter l'organisation.`} type="error" danger />
      )} */}
    </div>
  )
}

export default CompanyCreate
